export interface ConceptoPlanilla {
  idConcepto: number;
  codigo: string;
  codigoPDT: string | null;
  descripcion: string;
  descripcionCorta: string | null;
  tipoConcepto: string; // R=Remuneracion, D=Descuento, A=Aporte patronal
  tipoCalculo: string;  // FIJO, VARIABLE, FORMULA, PORCENTAJE
  afectaCTS: boolean;
  afectaGratificacion: boolean;
  afectaVacaciones: boolean;
  afectaRenta5ta: boolean;
  afectaEsSalud: boolean;
  afectaPensiones: boolean;
  afectaSCTR: boolean;
  afectaUtilidades: boolean;
  afectaSENATI: boolean;
  aplicaEmpleados: boolean;
  aplicaObreros: boolean;
  porcentajeBase: number | null;
  formula: string | null;
  orden: number;
  activo: boolean;
  esConceptoSistema: boolean;
  // Granular affectation flags
  afectaDiasLaborados: boolean;
  afectaHorasExtras: boolean;
  afectaHorasNocturnas: boolean;
  afectaDiasSubsidiados: boolean;
  afectaTardanzas: boolean;
  afectaDescuentoSemanal: boolean;
  afectaFeriados: boolean;
  afectaQuincena: boolean;
  esProyectada: boolean;
  escalaDirecta: boolean;
  tipoRemuneracion: string | null; // PRINCIPAL, COMPLEMENTARIA, OTRAS
}

export const TIPOS_CONCEPTO = [
  { value: 'R', label: 'Remuneración' },
  { value: 'D', label: 'Descuento' },
  { value: 'A', label: 'Aporte Patronal' },
];

export const TIPOS_CALCULO = [
  { value: 'FIJO', label: 'Fijo' },
  { value: 'VARIABLE', label: 'Variable' },
  { value: 'FORMULA', label: 'Fórmula' },
  { value: 'PORCENTAJE', label: 'Porcentaje' },
];

export const TIPOS_REMUNERACION = [
  { value: 'PRINCIPAL', label: 'Principal' },
  { value: 'COMPLEMENTARIA', label: 'Complementaria' },
  { value: 'OTRAS', label: 'Otras' },
];

export const initialConcepto: ConceptoPlanilla = {
  idConcepto: 0,
  codigo: '',
  codigoPDT: null,
  descripcion: '',
  descripcionCorta: null,
  tipoConcepto: 'R',
  tipoCalculo: 'FIJO',
  afectaCTS: false,
  afectaGratificacion: false,
  afectaVacaciones: false,
  afectaRenta5ta: false,
  afectaEsSalud: false,
  afectaPensiones: false,
  afectaSCTR: false,
  afectaUtilidades: false,
  afectaSENATI: false,
  aplicaEmpleados: true,
  aplicaObreros: true,
  porcentajeBase: null,
  formula: null,
  orden: 0,
  activo: true,
  esConceptoSistema: false,
  afectaDiasLaborados: false,
  afectaHorasExtras: false,
  afectaHorasNocturnas: false,
  afectaDiasSubsidiados: false,
  afectaTardanzas: false,
  afectaDescuentoSemanal: false,
  afectaFeriados: false,
  afectaQuincena: false,
  esProyectada: false,
  escalaDirecta: false,
  tipoRemuneracion: null,
};

export interface ConceptoFormErrors {
  codigo?: string;
  descripcion?: string;
  tipoConcepto?: string;
}
